// Where the admin's tokens live (spec 02 D10):
//   access token  -> module memory only (gone on reload, never written anywhere)
//   refresh token -> sessionStorage (survives a reload, gone when the tab closes)
// Nothing here logs, and nothing goes to localStorage or a URL.

const REFRESH_KEY = "persona_admin_refresh";

let accessToken: string | null = null;
// Fallback for when sessionStorage is blocked (private mode, storage disabled).
let memoryRefreshToken: string | null = null;

export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  try {
    return window.sessionStorage.getItem(REFRESH_KEY) || memoryRefreshToken;
  } catch {
    return memoryRefreshToken;
  }
}

export function setTokens(pair: TokenPair): void {
  accessToken = pair.accessToken || null;
  memoryRefreshToken = pair.refreshToken || null;
  try {
    if (pair.refreshToken) window.sessionStorage.setItem(REFRESH_KEY, pair.refreshToken);
    else window.sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    // Blocked storage: the in-memory copy above still carries this tab's session.
  }
}

export function clearTokens(): void {
  accessToken = null;
  memoryRefreshToken = null;
  try {
    window.sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    // nothing to clear
  }
}
